import { render, staticRenderFns } from "./ProductCenterGridOthers.vue?vue&type=template&id=9a2045ac&scoped=true"
import script from "./ProductCenterGridOthers.vue?vue&type=script&lang=js"
export * from "./ProductCenterGridOthers.vue?vue&type=script&lang=js"
import style0 from "./ProductCenterGridOthers.vue?vue&type=style&index=0&id=9a2045ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2045ac",
  null
  
)

export default component.exports